
import { Component, Vue } from "vue-property-decorator";
import { UserManagementState, Domain, DomainModal } from '@/store/user-management/types';
import { namespace } from 'vuex-class';
import { VueBootstrapField } from '@/store/types';
import ConfirmationModal from "@/components-shared/ConfirmationModal.vue"
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import AddEditDomainModal from "./AddEditDomainModal.vue";

const UserManagement = namespace("userManagement");
const Areas = namespace("areas");


@Component({
    components: {
        "confirmation-modal": ConfirmationModal,
        "vue-perfect-scrollbar": VuePerfectScrollbar,
        AddEditDomainModal
    }
})
export default class DomainTableSetup extends Vue {
    @UserManagement.State((state: UserManagementState) => state.domains) private domains: Domain[]; 
    @UserManagement.Action private loadAllDomains: () => void;
    @UserManagement.Mutation setDomainModalShown: (domainModal: DomainModal) => void;
    @UserManagement.Action deleteDomain: (domainId: number) => Promise<void>;

    @Areas.Action getAreaList: () => Promise<void>;
	@Areas.Getter getAreaTitleById: (groupId: number) => string;

    private showConfirmationModal: boolean = false;
    private confirmationModalMessage: string = null;
    private confirmModalOkButtonText: string = null;
    private confirmModalCancelButtonText: string = null;
    private confirmModalDeletion: boolean = false;
    private confirmModalTitle: string = "Confirmation Modal";

    private deleteDomainId: number = null;
    private filterSearchDomain: string = "";
    private selectedDomainId: number = 0;

    private fields: VueBootstrapField[] = [
		{ key: 'domainName', label: 'Domain', sortable: true},
		{ key: 'groupId', label: 'Area', sortable: true,
            formatter: (groupId, key, item) => groupId > 0 ? this.getAreaById(groupId) : ""
		},
        { key: 'actions', label: 'Actions', sortable: false }
	];

    private async mounted(){
        await this.getAreaList();
        await this.loadAllDomains();
    }

    private getAreaById(groupId): string {
		// This needs to exist due to formatter within vue bootstrap table
		// using vuex getter will be outside the 'this' scope
		return this.getAreaTitleById(groupId);
	}

    private addDomain(): void{
        this.setDomainModalShown({shown: true, domainId: 0})
    }

    private editDomain(item: Domain): void{
        this.setDomainModalShown({shown: true, domainId: item.domainId})
    }

    private deleteDomainButton(): void{
        this.deleteDomain(this.deleteDomainId);

        if(this.deleteDomainId == this.selectedDomainId){
            this.$emit("selected-domain", null);
            this.selectedDomainId = 0;
        }

        this.deleteDomainId = null;      

        this.closeConfirmationModal();
    }

    private viewDomainMapping(item: Domain) {
        this.selectedDomainId = item.domainId;
        this.$emit("selected-domain", item.domainId);
    }

    private checkDeleteDomain(item: Domain){
        this.deleteDomainId = item.domainId;
        let message: string = "Are you sure you want to delete '" + item.domainName + "' domain?"; 
        this.openConfirmationModal("Delete Domain", message, true, "DELETE", "Cancel")
    }

    private openConfirmationModal(title: string, message: string, deletion: boolean, okText: string, cancelText: string) {
        this.confirmModalDeletion = deletion;
        this.confirmModalOkButtonText = okText;
        this.confirmModalCancelButtonText = cancelText;
        this.confirmationModalMessage = message;
        this.confirmModalTitle = title;
        this.showConfirmationModal = true;
    }

    private closeConfirmationModal() {     
        this.deleteDomainId = null;
        this.showConfirmationModal = false;
        this.confirmModalDeletion = false;
        this.confirmModalOkButtonText = "";
        this.confirmModalCancelButtonText = "OK";
        this.confirmationModalMessage = "";
        this.confirmModalTitle = "";
    }

    private filterFunction(row : Domain, filter: string){
        filter = filter.toUpperCase().trim();
        if (row.domainName.toUpperCase().includes(filter) || this.getAreaById(row.groupId).toUpperCase().includes(filter)) {
            return true;
        } else {
            return false;
        }
    }

    private rowClass(item: Domain) {
        if(item !== null){
            if (item.domainId == this.selectedDomainId){ 
                return 'table-primary hover-icon'
            }else {
                return "hover-icon"
            }         
        }      
    }
}
